/**
 * My Tasks service — cross-project task aggregation + personal to-dos.
 *
 * Backing endpoints (Maestro):
 *   GET    /v1/tasks/mine                     — projects (with canWrite), my
 *                                               assigned project tasks, my
 *                                               personal tasks
 *   POST   /v1/tasks/personal                 — create a personal task
 *   PUT    /v1/tasks/personal/:taskId         — update a personal task
 *   DELETE /v1/tasks/personal/:taskId         — delete a personal task
 *   PUT    /v1/project/:id/tasks/:taskId      — update a project task (needs
 *                                               project.management.write —
 *                                               see canWrite from /mine)
 */
import apiService from '../../../shared/services/apiService';

export async function fetchMyTasks(token) {
  return apiService.get('/v1/tasks/mine', token);
}

// Cross-project portfolio timeline: every task the caller can SEE (trimmed
// scheduling fields) across all their active projects.
export async function fetchTaskPortfolio(token) {
  return apiService.get('/v1/tasks/portfolio', token);
}

// Full project document — needed before navigating to a project page, because
// AuthContext.selectedProject must hold the complete object other pages read.
export async function fetchProject(projectId, token) {
  return apiService.get(`/v1/project/${projectId}`, token);
}

export async function createPersonalTask(data, token) {
  return apiService.post('/v1/tasks/personal', data, token);
}

export async function updatePersonalTask(taskId, data, token) {
  return apiService.put(`/v1/tasks/personal/${taskId}`, data, token);
}

export async function deletePersonalTask(taskId, token) {
  return apiService.delete(`/v1/tasks/personal/${taskId}`, token);
}

export async function updateProjectTask(projectId, taskId, data, token) {
  return apiService.put(`/v1/project/${projectId}/tasks/${taskId}`, data, token);
}
